import { computed } from 'vue'
import { type RouteRecordName, type RouteParamsRaw, useRouter } from 'vue-router'
import { EErrorKeys } from '../enum/errors-keys.enum'
import { useChannels } from './useChannels'
import { isShortLink } from '@/business-rules'
import { EPage } from '../enum/page.enum'
import { flowType } from '@/shared/constants/flow-type.constants'

export const useAppRouter = () => {
  const router = useRouter()
  const { isMCAppChannel, isChatbotChannel } = useChannels()

  const currentRouteName = computed(() => router.currentRoute.value.name)
  const currentRouteParams = computed(() => router.currentRoute.value.params)

  const navigateToRoute = (name: RouteRecordName, params?: RouteParamsRaw) => {
    router.push({ name, params })
  }

  const redirectionPage = (campaign: string, flowTypeValue: string, errorKey?: EErrorKeys) => {
    if (isMCAppChannel.value) {
      if (flowTypeValue === flowType.SEND_RECHARGES) {
        navigateToRoute(EPage.SEND_RECHARGES)
        return
      }
      const { VUE_APP_REDIRECT } = process.env
      window.location.href = `${VUE_APP_REDIRECT}exit`
    }
    const errorKeys = [
      EErrorKeys.PERMANENT_BLACKLIST,
      EErrorKeys.LINE_SUSPENDED,
      EErrorKeys.INVALID_MSISDN
    ]
    const route =
      !isShortLink(campaign) || errorKeys.includes(errorKey as EErrorKeys)
        ? EPage.LANDING
        : EPage.PACKAGES

    if (!isChatbotChannel.value) navigateToRoute(route)
  }

  return {
    currentRouteName,
    currentRouteParams,
    navigateToRoute,
    redirectionPage
  }
}
